@if (showUnpStatus && !isLoading) {
  <div @fadeInOut>
    @if (unpStatus.is_access_status) {
      <div class="unp-status">
        <span [inlineSVG]="'../assets/img/icons/unp-status-ok.svg'"></span>
        <div class="unp-status__text">
          {{ 'UNPSTATUS.' + statusTranslit | translate }}
        </div>
      </div>
    }
    @if (!unpStatus.is_access_status) {
      <div class="unp-status">
        <span [inlineSVG]="'../assets/img/icons/unp-status-bad.svg'"></span>
        <div class="unp-status__text">
          {{ 'UNPSTATUS.' + statusTranslit | translate }}
        </div>
      </div>
    }
  </div>
}
@if (isLoading) {
  <div class="d-flex">
    <span
      class="spinner-border spinner-border spinner-border-lg text-secondary loading"
      role="status"
      aria-hidden="true"
    ></span>
  </div>
}
